<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small"
            @change="inputChange">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="顾客类型：">
          <el-select v-model="formInline.customerType" placeholder="请选择顾客类型" filterable size="small"
            @change="inputChange">
            <el-option v-for="item in customerTypeList" :label="item.value" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档案编号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerNo"
            placeholder="请输入档案编号"></el-input>
        </el-form-item>
        <el-form-item label="顾客姓名：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.name"
            placeholder="请输入顾客姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.phone"
            placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="进店类型：">
          <el-select v-model="formInline.inStoreType" placeholder="请选择进店类型" filterable size="small"
            @change="inputChange">
            <el-option v-for="item in inStoreTypeList" :label="item.value" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学校名称" prop="schoolName">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.schoolName"
            placeholder="请输入学校名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'reset')" size="small" icon="el-icon-refresh"
            @click="clearAll">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button v-if="this.$checkBtnPermission('/customer/index', 'create')" size="small" type="primary"
            class="el-icon-plus" @click="handleEdit()">新增
          </el-button>
          <my-column-filter v-if="this.$checkBtnPermission('/customer/index', 'myFilter')" :listColumns="listColumns"
            @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @handle-command="handleCommand" @rowDBClick="handleRowClick" border>
        <el-table-column align="center" slot="name" label="顾客姓名" width="120" fixed="left">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="handleSelectOrderPage(scope.row)">
              {{ scope.row.name }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" slot="gender" label="性别" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.gender == 1" class="one_1">
              {{ formatterFre(scope.row.gender) }}</span>
            <span v-if="scope.row.gender == 0" class="one_2">
              {{ formatterFre(scope.row.gender) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" slot="isGrantCommission" label="是否创建提成" width="130">
          <template slot-scope="scope">
            <span v-if="scope.row.isGrantCommission" class="one_1">是</span>
            <span v-else class="one_2">未发放</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" slot="operation" label="操作" min-width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="btnPermissionList.commission && !scope.row.isGrantCommission && scope.row.inStoreType == 3" size="mini" type="primary"
              class="el-icon-edit" @click="handleCommissionClick(scope.row)">提成
            </el-button>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <!-- 编辑 -->
    <edit ref="edit"></edit>
    <!-- 选择订单 -->
    <selectOrderPage ref="selectOrderPage"></selectOrderPage>
    <!-- 提成 -->
    <el-dialog title="顾客提成" :visible.sync="commissionShow" width="50%">
      <span style="display: block; margin-bottom: 10px"><strong>提成类型:</strong></span>
      <el-radio-group v-model="commissionGrant.type" size="small">
        <el-radio :label="1" style="margin-right: 10px;">跑单会员提成</el-radio>
        <el-radio :label="2" style="margin-right: 10px;">进店成交提成</el-radio>
      </el-radio-group>
      <span style="display: block; margin-bottom: 10px"><strong>提成员工:</strong></span>
      <el-select v-model="commissionGrant.commissionUserKeyId" placeholder="请选择提成员工" filterable size="small"
        style="width: 100%;">
        <el-option v-for="item in employeeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="commissionShow = false" icon="el-icon-close" size="small">关闭</el-button>
        <el-button @click="handleGrantCommissionClick" icon="el-icon-check" size="small" type="primary">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerInfoPageList,
  deleteCustomerInfo,
  GrantVipCommission
} from "@/api/baseDataApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import {
  GetUserBindSelectByPermission
} from "@/api/userApi.js";
import edit from "./edit";
import selectOrderPage from "./selectOrderPage.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "顾客列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      storeList: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        name: "",
        phone: "",
        belongStoreKeyId: "",
        customerType: 0,
        customerNo: "",
        inStoreType: 0,
      },
      columnsData: [],
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "createTime",
          label: "创建时间",
          align: "center",
          width: "160",
          fixed: "left",
        },
        {
          prop: "belongStoreName",
          label: "所属门店",
          align: "center",
          width: "80",
          fixed: "left",
        },
        {
          slot: "name",
          label: "顾客姓名",
          align: "center",
          isKeep: true,
          minWidth: "120",
          fixed: "left",
        },
        {
          prop: "age",
          label: "年龄",
          align: "center",
          width: "80",
        },
        {
          prop: "customerTypeStr",
          label: "会员类型",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "customerNo",
          label: "档案编号",
          align: "center",
          isKeep: true,
          minWidth: "120",
        },
        {
          prop: "inStoreTypeStr",
          label: "进店类型",
          align: "center",
          width: "120",
        },
        {
          prop: "phone",
          label: "联系电话",
          align: "center",
          width: "120",
        },
        {
          slot: "gender",
          label: "性别",
          align: "center",
          width: "80",
        },
        {
          prop: "schoolName",
          label: "学校名称",
          align: "center",
          width: "120",
        },
        {
          prop: "grantUserName",
          label: "创建提成人",
          align: "center",
          width: "90",
        },
        {
          prop: "grantTime",
          label: "创建提成时间",
          align: "center",
          width: "160",
        },
        {
          prop: "commissionUserName",
          label: "提成员工",
          align: "center",
          width: "100",
        },
        {
          prop: "commissionMoney",
          label: "提成金额",
          align: "center",
          width: "100",
        },
        {
          prop: "creator",
          label: "创建人",
          align: "center",
          width: "80",
        },
        {
          prop: "editor",
          label: "维护人",
          align: "center",
          width: "80",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          align: "center",
          width: "160",
        },
        {
          slot: "operation",
          label: "操作",
          align: "center",
          width: "180",
          fixed: "right",
        },
      ],
      customerTypeList: [],
      btnPermissionList: {
        commission: false
      },
      // 提成
      commissionShow: false,
      employeeList: [],
      commissionGrant: {
        keyId: "",
        commissionUserKeyId: "",
        type: 1,
      },
      inStoreTypeList: [],
    };
  },
  // 注册组件
  components: {
    edit,
    selectOrderPage,
  },
  created() {
    this.GetOrgInfoListByConfig();
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetEnumConfigListByCode();
    this.getBtnPermissionList();
    this.GetUserBindSelectByPermission();
    this.GetInStoreTypeList();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 获取按钮权限
    getBtnPermissionList() {
      this.btnPermissionList.commission = this.$checkBtnPermission('/customer/index', 'commission')
    },
    // 性别
    formatterFre(gender) {
      return gender == 1 ? "男" : gender == 0 ? "女" : "";
    },
    changePages() { },
    handleCommand(command) {
      // 1编辑
      switch (command.command) {
        case "4":
          this.deleteCustomer(command.rowData);
          break;
        default:
          console.log(command);
      }
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            res.data.forEach((item) => {
              this.storeList.push({
                keyId: item.keyId,
                value: item.name + '【' + item.remark2 + '】',
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 获取顾客类型
    GetEnumConfigListByCode() {
      const paramer = {
        code: "CustomerType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.customerTypeList = [];
            res.data.forEach((item) => {
              this.customerTypeList.push({
                keyId: parseInt(item.code),
                value: item.name,
              });
            });
            this.customerTypeList.unshift({
              keyId: 0,
              value: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取顾客类型信息失败!");
        });
    },
    // 单击行数据
    handleRowClick(row) {
      this.$refs.edit.editShow(row);
    },
    //显示编辑界面
    handleEdit(row) {
      this.$refs.edit.editShow(row);
    },
    // 删除
    deleteCustomer(row) {
      this.$confirm("确定要删除顾客【" + row.name + "】吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let parmter = {
          keyId: row.keyId,
        };
        deleteCustomerInfo(parmter)
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "已删除!",
              });
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("删除失败，请稍后再试！");
          });
      });
    },
    // 获取列表
    getListData() {
      this.loading = true;
      getCustomerInfoPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 提成
    handleCommissionClick(row) {
      this.commissionShow = true;
      this.commissionGrant = {
        keyId: row.keyId,
        type: 1,
        commissionUserKeyId: "",
      };
      this.GetUserBindSelectByPermission(row.belongStoreKeyId);
    },
    // 确认提成
    handleGrantCommissionClick() {
      if (this.commissionGrant.commissionUserKeyId == "") {
        this.$message.error("请选择提成员工");
        return;
      }
      this.$confirm("确定提成给选中的员工吗?\n", "信息(一经给出，无法撤回)", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        GrantVipCommission(this.commissionGrant)
          .then((res) => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: "提成设置成功!",
              });
              this.commissionShow = false;
              this.getListData();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("提成设置失败，请稍后再试！");
          }).finally(() => {
            this.loading = false;
          });
      });
    },
    // 获取人员信息绑定下拉框_根据权限
    GetUserBindSelectByPermission(val) {
      const paramer = {
        keyId: val
      };
      GetUserBindSelectByPermission(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.employeeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取人员信息失败!");
        });
    },
    // 选择订单
    handleSelectOrderPage(row) {
      this.$refs.selectOrderPage.showSelectOrderDialog(row.keyId);
    },
    // 获取进店类型
    GetInStoreTypeList() {
      const paramer = {
        code: "InStoreType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.inStoreTypeList = [];
            res.data.forEach((item) => {
              this.inStoreTypeList.push({
                keyId: parseInt(item.code),
                value: item.name,
              });
            });
            this.inStoreTypeList.unshift({
              keyId: 0,
              value: "全部",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取进店类型信息失败!");
        });
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>